import React, { useState, useEffect } from "react";
import {
  deleteIsReadNotifications,
  deleteNotification,
  getNotifications,
  markNotificationsAsRead,
  updateNotification,
} from "../../api/NotificationApi";
import { NotificationListForm } from "./NotificationListForm";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import { appTitle } from "../common/GeneralConfigurations";
import { adnPageSize } from "../common/GeneralConfigurations";
import { getAuthenticatedUserId } from "../../api/ApiUtils";

export const ManageNotificationListPage = () => {
  const title = "Notifications";
  const [notifications, setNotifications] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = `${appTitle} - Notifications`;
  }, []);

  useEffect(() => {
    loadMoreNotifications();
  }, [totalRecords])

  const loadMoreNotifications = async () => {
    await getNotifications(pageNumber, 30)
      .then((res) => {
        setTotalRecords(res.data.totalRecords);
        setNotifications((currentNotifications) => [
          ...currentNotifications,
          ...res.data.result,
        ]);
        setLoading(false);
      })
      .then(setPageNumber(pageNumber + 1));
  };

  const refreshNotifications = async () => {
    let notifications = [];
    for (let i = 1; i < pageNumber; i++) {
      await getNotifications(i, adnPageSize).then((res) => {
        notifications.push(...res.data.result);
      });
    }
    setNotifications(notifications);
  };

  const toggleIsRead = async (id) => {
    await updateNotification(id).then((res) => {
      if (res.status === 200) {
        refreshNotifications();
      }
    });
  };

  const handleDelete = async (id) => {
    await deleteNotification(id).then((res) => {
      if (res.status == 200) {
        refreshNotifications();
        AdnMessageSuccess();
      } else {
        AdnMessageError();
      }
    });
  };

  const handleDeleteIsReadNotifications = async () => {
    await deleteIsReadNotifications()
      .then((res) => {
        if (res.status === 200) {
          AdnMessageSuccess(res.data + " notifications have been deleted.");
          refreshNotifications();
        } else if (res.status === 400) {
          res.data.errors.map((e) => {
            AdnMessageError(e.message);
          });
        } else if (res.status === 404) {
          AdnMessageError("You don't have any notifications read to delete.");
        } else {
          AdnMessageError("Could not delete notifications.");
        }
      }).catch(() => {
        AdnMessageError("Could not get notifications.");
      })
  }

  const handleMarkNotificationsAsRead = async () => {
    var userId = getAuthenticatedUserId();
    await markNotificationsAsRead({ userId })
      .then((res) => {
        if (res.status === 200) {
          AdnMessageSuccess("All notifications have been marked as read.");
          refreshNotifications();
        } else {
          AdnMessageError("The notifications could not be marked as read.");
        }
      }).catch(() => {
        AdnMessageError("The notifications could not be marked as read.");
      })
  }

  return (
    <NotificationListForm
      title={title}
      notifications={notifications}
      loadMore={loadMoreNotifications}
      totalRecords={totalRecords}
      toggleIsRead={toggleIsRead}
      handleDelete={handleDelete}
      loading={loading}
      handleDeleteIsReadNotifications={handleDeleteIsReadNotifications}
      handleMarkNotificationsAsRead={handleMarkNotificationsAsRead}
    />
  );
};
